/**
 * Focus-route list (ADR-087): surfaces where we should not interrupt the user
 * with non-urgent toast notifications. Practice / performance / test-taking
 * spaces where latency or visual interruption breaks the core interaction.
 *
 * Prefix match — so `/opdrachten/` covers `/opdrachten/xyz123`.
 */
export const FOCUS_ROUTE_PREFIXES: readonly string[] = [
	'/drumpad',
	'/pad',
	'/piano',
	'/performer',
	'/opdrachten/',
	'/backing-tracks',
] as const

export function isFocusRoute(pathname: string): boolean {
	return FOCUS_ROUTE_PREFIXES.some((prefix) =>
		prefix.endsWith('/') ? pathname.startsWith(prefix) : pathname === prefix,
	)
}
